module.exports = __webpack_public_path__ + "img/spa-beautician.2fcd32f0.svg";